<template>
    <modal-page :heading="($config.auth || {}).loginHeadingOverride || 'Sign In'">
        <login-form
            class="login-form"
            username-placeholder="Email Address"
            username-validation-rules="required|email"
            :on-valid-submit="login"
            :username-initial-value="($config.auth || {}).loginUsernameDefault || ''">
        </login-form>
        <p class="forgot-password"><router-link :to="{ name: 'forgot-password' }">Forgot Password?</router-link></p>
        <p class="register">Don't have an account? <router-link :to="{ name: 'register' }">Sign up</router-link></p>
    </modal-page>
</template>

<script>
import errorHandleable from '../mixins/ErrorHandleable'
import loginForm from '../components/LoginForm.vue'
import modalPage from '../components/ModalPage.vue'
import quebecUserModal from '../mixins/QuebecUserModal'
import trackable from '../mixins/Trackable'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Sign-in at ${this.$config.partnerName}`
    },
    components: {
        loginForm,
        modalPage
    },
    created () {
        if (this.$store.state.userProfile) {
            this.$router.replace({ name: 'home' })
        } else {
            this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        login (username, password) {
            this.$store.dispatch('loginConcierge', { username, password })
                .then(() => {
                    if (this.$route.query.continue) {
                        this.$router.replace(this.$route.query.continue)
                    } else {
                        this.$router.replace({ name: 'home' })
                    }
                })
                .catch(err => this.catchAndNotify(err))
        }
    },
    mixins: [
        errorHandleable,
        quebecUserModal,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
.forgot-password {
    margin: 0 0 30px;
    text-align: right;
}

.intro {
    font-size: 16px;
    margin: 0 0 30px;
    text-align: center;
}

.login-form {
    margin-top: 30px;
}

.register {
    margin: 0;
    text-align: center;
}
</style>
